import request from '@/api/request'

export function doLogin(target, pwd) {
    // let params = new URLSearchParams(data).toString();
    return request({
        url: `/login/pwd?target=${target}&pwd=${pwd}`,
        method: 'post'
    })
}

